export interface Kit {
  id: string
  name: string
  badge: string
  color: string
  textColor: string
  borderColor: string
  description: string
  bonuses: string[]
  oldPrice: number
  price: number
  icon: string
  image: string
}

export const KITS: Kit[] = [
  {
    id: 'completa',
    name: 'Kit Alimentación Completa',
    badge: 'MÁS POPULAR',
    color: 'bg-combo-green',
    textColor: 'text-combo-green',
    borderColor: 'border-combo-green',
    description:
      'Ideal para personas que quieren ordenar su alimentación desde cero.',
    bonuses: [
      '40 recetas desayunos y meriendas',
      '40 recetas almuerzos y cenas',
      '50 recetas para diabéticos',
    ],
    oldPrice: 29980,
    price: 14990,
    icon: 'Salad',
    image:
      'https://cdn.magicpatterns.com/uploads/txUCndoAYuPUx4sJe9oq2s/ChatGPT_Image_27_may_2026,_01_57_49_p.m..png',
  },
  {
    id: 'cardio',
    name: 'Kit Salud Cardiovascular',
    badge: 'RECOMENDADO POR NUTRICIONISTAS',
    color: 'bg-combo-navy',
    textColor: 'text-combo-navy',
    borderColor: 'border-combo-navy',
    description:
      'Diseñado para personas que necesitan mejorar su alimentación por indicación médica.',
    bonuses: [
      '40 recetas descenso de peso',
      '40 recetas colesterol/triglicéridos/LDL',
      '50 recetas para hipertensos',
    ],
    oldPrice: 29980,
    price: 14990,
    icon: 'Heart',
    image:
      'https://cdn.magicpatterns.com/uploads/uAxjaTCVuYq2Q42fKJAn2c/Mockup_kit_salud_cardiovascular.png',
  },
  {
    id: 'fitness',
    name: 'Kit Fitness & Proteínas',
    badge: 'IDEAL PARA DEPORTISTAS',
    color: 'bg-combo-burgundy',
    textColor: 'text-combo-burgundy',
    borderColor: 'border-combo-burgundy',
    description:
      'Para personas que entrenan y quieren resultados reales desde la nutrición.',
    bonuses: [
      '40 desayunos proteicos',
      '40 almuerzos proteicos',
      '50 recetas con whey protein',
    ],
    oldPrice: 29980,
    price: 14990,
    icon: 'Dumbbell',
    image:
      'https://cdn.magicpatterns.com/uploads/fxvpzLm8pRPZ24Q1gH7fqm/Mockup_kit_fitness.png',
  },
]
